import * as R from 'ramda'

export const insuredRelationship: {
  [key: string]: string;
} = {
  NAMED_INSURED: 'Named Insured',
  SPOUSE: 'Spouse',
  CHILD: 'Child',
  PARTNER: 'Partner',
  OTHER: 'Other'
}
export const relationKeys = R.keys(insuredRelationship)
export const relationValues = R.values(insuredRelationship)

export const insuredGender: {
  [key: string]: string;
} = {
  MALE: 'Male',
  FEMALE: 'Female'
}
export const genderKeys = R.keys(insuredGender)
export const genderValues = R.values(insuredGender)

export const insuredIncludedOrExcluded: {
  [key: string]: string;
} = {
  INCLUDED: 'Included',
  EXCLUDED: 'Excluded'
}
export const includedKeys = R.keys(insuredIncludedOrExcluded)
export const includedValues = R.values(insuredIncludedOrExcluded)

export const insuredEducationLevel: {
  [key: string]: string;
} = {
  HIGN_SCHOOL_DIPLOMA: 'High School Diploma',
  ASSOCIATES_DEGREE: 'Associated Degree',
  BACHELORS_DEGREE: 'Bachelor\'s Degree',
  NONE: 'none',
  OTHER: 'other'
}
export const educationKeys = R.keys(insuredEducationLevel)
export const educationValues = R.values(insuredEducationLevel)

export const insuredLicenseStatus: {
  [key: string]: string;
} = {
  VALID: 'Valid',
  SUSPENDED: 'Suspended',
  PERMIT: 'Permit'
}
export const licenseKeys = R.keys(insuredLicenseStatus)
export const licenseValues = R.values(insuredLicenseStatus)

export const insuredMaritalStatus: {
  [key: string]: string;
} = {
  SINGLE: 'Single',
  MARRIED: 'Married'
}
export const maritalKeys = R.keys(insuredMaritalStatus)
export const maritalValues = R.values(insuredMaritalStatus)

export const insuredDUI: {
  [key: string]: string;
} = {
  NO: 'no',
  YES: 'yes'
}
export const duiKeys = R.keys(insuredDUI)
export const duiValues = R.values(insuredDUI)

export const insuredSROrFR: {
  [key: string]: string;
} = {
  NO: 'no',
  SR22: 'SR22',
  FR44: 'FR44'
}
export const srKeys = R.keys(insuredSROrFR)
export const srValues = R.values(insuredSROrFR)

export const insuredHealthClass: {
  [key: string]: string;
} = {
  PREFFERED: 'Preffered',
  STANDARD: 'Standard',
  NON_STANDARD: 'NonStandard'
}
export const healthKeys = R.keys(insuredHealthClass)
export const healthValues = R.values(insuredHealthClass)
